import dayjs from 'dayjs';

const DASH = '—';
const km = (knots) => `${Math.round((knots || 0) * 1.852)} km/h`;

export const LABEL_FIELDS = [
  { key: 'name',     group: 'basic', label: 'Name',     format: (_p, d) => d?.name || DASH },
  { key: 'speed',    group: 'basic', label: 'Speed',    format: (p) => km(p.speed) },
  { key: 'heading',  group: 'basic', label: 'Heading',  format: (p) => (p.course == null ? DASH : `${Math.round(p.course)}°`) },
  { key: 'time',     group: 'basic', label: 'Time',     format: (p) => (p.fixTime ? dayjs(p.fixTime).format('HH:mm:ss') : DASH) },
  { key: 'altitude', group: 'basic', label: 'Altitude', format: (p) => (p.altitude == null ? DASH : `${Math.round(p.altitude)} m`) },
];

export const DEFAULT_LABEL_FIELDS = ['name', 'speed'];

const BASIC_KEYS = new Set(LABEL_FIELDS.map((f) => f.key));

/** Attribute keys present on a fix that aren't already basic fields. */
export function availableSensorFields(pos) {
  if (!pos || !pos.attributes) return [];
  return Object.keys(pos.attributes).filter((k) => !BASIC_KEYS.has(k));
}

/** Render the selected field keys into label lines. Unknown keys are treated as sensor attributes. */
export function renderLabel(pos, device, fieldKeys) {
  return (fieldKeys || []).map((key) => {
    const basic = LABEL_FIELDS.find((f) => f.key === key);
    if (basic) {
      const val = basic.format(pos, device);
      // The name is the bold title line — no prefix. Everything else is shown
      // as "Label: value" so a column of numbers isn't ambiguous.
      return key === 'name' ? val : `${basic.label}: ${val}`;
    }
    const raw = pos?.attributes?.[key];
    const val = raw == null || raw === '' ? DASH : formatSensorValue(raw);
    return `${prettyKey(key)}: ${val}`;
  });
}

/** "sat" → "Sat", "batteryLevel" → "BatteryLevel" (just upper-cases the first char). */
function prettyKey(key) {
  return key.charAt(0).toUpperCase() + key.slice(1);
}

/** Round noisy floats (e.g. 11.248000000000001 → 11.25); leave integers/strings as-is. */
export function formatSensorValue(raw) {
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (typeof raw !== 'boolean' && Number.isFinite(n) && String(raw).trim() !== '') {
    return Number.isInteger(n) ? String(n) : n.toFixed(2);
  }
  return String(raw);
}
